module.exports = __webpack_public_path__ + "img/android.191b7ca4.png";